import { Skeleton } from "@chakra-ui/react"

import { VStack } from "@chakra-ui/react"

function ActivityLoading() {
  return (
    <VStack gap={4} align="stretch" width="100%" height="100%">
      <Skeleton height="150px" />
      <Skeleton height="100px" />
      <Skeleton height="100px" />
    </VStack>
  )
}

export default ActivityLoading
